export enum PermissionType {
    // ----------------------------------------------------
    // Roles
    // ----------------------------------------------------
    RoleList = 1,
    RoleAdd = 2,
    RoleEdit = 3,
    RoleDelete = 4,
    RoleViewDetail = 5,

    // ----------------------------------------------------
    // User
    // ----------------------------------------------------
    UserList = 10,
    UserAdd = 11,
    UserEdit = 12,
    UserDelete = 13,
    UserViewDetail = 14,

    // ----------------------------------------------------
    // Tenant
    // ----------------------------------------------------
    TenantList = 20,
    TenantAdd = 21,
    TenantEdit = 22,
    TenantDelete = 23,
    TenantViewDetail = 24,

    TenantSettings= 30,

    Approver = 31,

    FormList = 100,
    FormAdd = 101,
    FormEdit = 102,
    FormDelete = 103,
    FormViewDetail = 104,

    FormSubTypeList = 110,
    FormSubTypeAdd = 111,
    FormSubTypeEdit = 112,
    FormSubTypeDelete = 113,
    FormSubTypeViewDetail = 114,

    ComplaintList = 120,
    ComplaintViewDetail = 121,
    ComplaintClassification = 122,

    AlertList = 130,
    AlertAddManual = 131,
    AlertEdit = 132, 
    AlertViewDetail = 133,
    AlertMassiveActions = 134,
    AlertDelete = 135,

    CasesList = 140,
    CaseAddManual = 141,
    CaseEdit = 142,
    CaseViewDetail = 143,
    CaseDelete = 144,
    CaseFollowUpTaskAction = 145,

    FollowUpActionsList = 150,
    FollowUpActionsAdd = 151,
    FollowUpActionsEdit = 152,
    FollowUpActionsDelete = 153,
    FollowUpActionsViewDetail = 154,

    // FlatReport
    FlatReportComplaint = 155,
    FlatReportAlert = 156,
    FlatReportCase = 157,   
    FlatComplaintReportDetail = 158,
    FlatAlertReportDetail = 159,
    FlatCaseReportDetail = 160,
    BackToRequestFlatAlertReport = 161,
    BackToRequestFlatCaseReport = 162,
    BackToRequestFlatComplaintReport = 163,

    //Report PDF
    GenerateAlertReport = 164,
    GenerateCaseReport = 165,
    GenerateComplaintReport = 166,

    // Politics and Procedures
    PPUpload  =171,
    PPShare = 172,
    PPNotification = 173,
    PPCreateFolder = 174,
    PPNotifiedReport = 175,
    PPStructureReport = 176,
    PPViewApprovers = 177,
    PPCanBeReviewerFile = 178,
    PPCanBeViewerFile = 179,
    PPCanBeReviewerFolder = 180,
    PPCanBeViewerFolder = 181,
    PPList = 182,
    PPEdit = 183,
    PPViewDetail = 184,
    PPDelete = 185,
    PPcanBeApprover=186,
    PPcanBeDeleted=187,
    PPFileDisclaimerDelete = 188,
    PPFileDisclaimerEdit=189,
    PPFileDisclaimerAdd = 190,

    EditComplaintClassificationFromAlert = 200,
    
    PPApproverList = 201,
    PPEditApprovers = 202,
    PPVisualizarionList = 203,
    PPEditNotificationVisualization = 204,

    RequestFlatFilesReport = 205,

    SeeMockupRisk= 206,

    AlertCompleteContinueButton = 207,
    AletcompleteExtendTermButton = 208,
    
    AlertDownloadTemplate = 209,
    AlertImport = 210,
    AlertExportPDF = 211,
    AlertExportExcel = 212,
    AlertAssociate = 213,

    
    ViewComplaintClassificationFromAlert = 214,
    ViewAlertFromCase = 215,

    CanBeDeletedRequestFlatAlertReport=216,
    CanBeDeletedRequestFlatCaseReport = 217,
    CanBeDeletedRequestFlatComplaintReport = 218,
    CanBeDeletedRequestFlatAlertFileReport = 219,

 
    DisableSaveCase = 784,
    DisableContinueCase = 785,
    DisableReOpenCase = 786,


    FlatReportDetail = 220,

    DynamicFiltersDetail = 221,
    TenantColumnSettigEdit=222,
    DynamicFiltersCaseDetail = 223,

    ControlList = 300,
    ControlAddManual = 301,
    ControlEdit = 302, 
    ControlViewDetail = 303,
    ControlMassiveActions = 304,
    ControlDelete = 305,

    ParameterizationList = 310,
    ParameterizationAddManual = 311,
    ParameterizationEdit = 312, 
    ParameterizationViewDetail = 313,
    ParameterizationMassiveActions = 314,
    ParameterizationDelete = 315,

    ParameterizationOposicionList = 320,
    ParameterizationOposicionAddManual = 321,
    ParameterizationOposicionEdit = 322, 
    ParameterizationOposicionViewDetail = 323,
    ParameterizationOposicionMassiveActions = 324,
    ParameterizationOposicionDelete = 325,

    ParameterizationManualList = 330,
    ParameterizationManualAddManual = 331,
    ParameterizationManualEdit = 332, 
    ParameterizationManualViewDetail = 333,
    ParameterizationManualMassiveActions = 334,
    ParameterizationManualDelete = 335,

    ParameterizationRulesList = 340,
    ParameterizationRulesAddManual = 341,
    ParameterizationRulesEdit = 342,
    ParameterizationRulesViewDetail = 343, 
    ParameterizationRulesMassiveActions = 344,
    ParameterizationRulesDelete = 345,

    ControlResumeList = 350,
    
    ControlRejection = 360,

    ControlListRisk = 366,
    ControlListProccess = 367,
    ControlListType = 368,
    ControlListResponsible = 369,
    ControlListStatus = 370,
    ControlListFunction = 371,
    ControlListPeriodicity = 372,
    ControlListPhrase = 373,
    ControlListSearchConector = 374,
    ControlListColumnDefinition = 375,

    ParameterizationListStatus = 376,
    ParameterizationControlExecution = 377,

    SummaryControl = 378,
    SummaryControlParameterization = 379,
    SummaryControlRegister = 380,
    SummaryControlRegisterParameterization = 381,

    BoardList = 382,
    BoardAdd = 383,
    BoardEdit = 384, 
    BoardViewDetail = 385,
    BoardDelete = 386,
    BoardAdministrationList = 387,

    UserGroupList = 700,
    UserGroupAdd = 701,
    UserGroupEdit = 702,
    UserGroupDelete = 703,
    UserGroupViewDetail = 704,

    LabelList = 770,
    LabelAdd = 771,
    LabelEdit = 772,
    LabelDelete = 773,
    LabelViewDetail = 774,

    LabelCustomizationList = 780,
    LabelCustomizationEdit = 781,
    LabelCustomizationDelete = 782,
    LabelCustomizationViewDetail = 783,

    AssociatedProcessesList = 784,
    AssociatedProcessesAddManual = 785,
    AssociatedProcessesEdit = 786,
    AssociatedProcessesViewDetail = 787,
    AssociatedProcessesDelete = 788,

    ResponsibleList = 789,
    ResponsibleAddManual = 790,
    ResponsibleEdit = 791,
    ResponsibleViewDetail = 792,
    ResponsibleDelete = 793,

    PeriodicityList = 794,
    PeriodicityAddManual = 795,
    PeriodicityEdit = 796,
    PeriodicityViewDetail = 797,
    PeriodicityDelete = 798,

    ControlTypeList = 799,

    ControlTypeAddManual = 800,
    ControlTypeEdit = 801,
    ControlTypeViewDetail = 802,
    ControlTypeDelete = 803,

    RiskList = 804,
    RiskAddManual = 805,
    RiskEdit = 806,
    RiskViewDetail = 807,
    RiskDelete = 808,

    AuditList = 809,

    AlertCriticalityList = 820,
    AlertCriticalityAdd = 821,
    AlertCriticalityEdit = 822,
    AlertCriticalityDelete = 823,
    AlertCriticalityViewDetail = 824,

    // ----------------------------------------------------
    // COMPLAINTS PORTAL
    // ----------------------------------------------------
    FAQList = 50,
    FAQAdd = 51,
    FAQEdit = 52,
    FAQDelete = 53,
    FAQViewDetail = 54,  

    ContentList = 40,
    ContentAdd = 41,
    ContentEdit = 42,
    ContentDelete = 43,
    ContentViewDetail = 44,    

    ComplaintClassificationList = 90,
    ComplaintClassificationAdd = 91,
    ComplaintClassificationEdit = 92,
    ComplaintClassificationDelete = 93,
    ComplaintClassificationViewDetail = 94,

    RejectedReasonList = 830,
    RejectedReasonAdd = 831,
    RejectedReasonEdit = 832,
    RejectedReasonDelete = 833,
    RejectedReasonViewDetail = 834,    

    AlertDueDateList = 840,
    AlertDueDateAdd = 841,
    AlertDueDateEdit = 842,
    AlertDueDateDelete = 843,
    AlertDueDateViewDetail = 844,
}


